<template>
  <div v-if="false"></div>
</template>

<script>
export default {
  data() {
    return {
      metricId: process.env.VUE_APP_YA_METRIC,
    };
  },
  beforeCreate() {
    this.$debug(
      "YA METRICS: инициализирован счетчик " + process.env.VUE_APP_YA_METRIC
    );
    window.ym(process.env.VUE_APP_YA_METRIC, "init", {
      defer: true,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      trackHash: true,
    });
  },
  beforeDestroy() {
    this.$root.$off("reachGoal", this.reachGoal);
  },
  created() {
    this.$root.$on("reachGoal", this.reachGoal);
  },
  methods: {
    reachGoal(params) {
      if (window.ym) {
        window.ym(this.metricId, "reachGoal", params.goalName, params.data);
        this.$debug(
          "YANDEX METRICS: отправлено событие " + params.goalName,
          "success",
          params
        );
      }
    },
  },
};
</script>
